import { LayerTypeControlPageProps } from "../../types";
import { router } from "src/js/router/react-router";
import { BundleId } from "src/js/stores/map/store";
import { updateMapSettings } from "src/js/stores/map/actions/updateMapSettings";
import ROUTES from "src/js/router/routes";
import { Button } from "react-migration/components/Button/Button";
import { Icon } from "react-migration/components/Icon";

export const PropertyInformationControlPage = (_props: LayerTypeControlPageProps) => {
  const handleSearchClick = () => {
    updateMapSettings("activeSearch", BundleId.PROPERTY_INFORMATION);

    const mapState = JSON.parse(localStorage?.mapStateSettings || '{ "mapX": 53, "mapY": 0, "zoom": 10 }');
    /**
     * calling this synchronously seems to cause an error with deck.gl when navigating
     * from property information search results, to the map layers and then back to the property information search results
     * delaying this by a small amount seems to allow the removeFromMap call above to complete
     * before navigating and mounting a new google map instance
     */
    const stall = window.requestIdleCallback || ((cb) => setTimeout(cb, 100));
    stall(() => {
      router.push({
        name: ROUTES.LEGACY_SEARCH,
        params: {
          x: mapState.mapX,
          lat: mapState.mapX,
          y: mapState.mapY,
          lng: mapState.mapY,
          z: mapState.zoom,
          searchType: BundleId.PROPERTY_INFORMATION,
        },
      });
    });
  };

  return (
    <div className="p-2 rounded-sm bg-white flex flex-col gap-y-2">
      <div className="text-sm text-text-base-primary">
        Search for property information using use class, floor area and much more.
      </div>
      <Button onClick={handleSearchClick} variant="primary" size="sm" className="w-full">
        <Icon icon="icon-lt-search-line" size="sm" extraClasses="mr-2" />
        Search Property Information
      </Button>
    </div>
  );
};
